import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";
import {camStudyService} from "@/core/service/camstudy/room.camstudy.service";
import {RoomFile} from "@/core/api/room.file.api";

class RoomCamStudyApi extends BaseApi {
  #camStudyRoomInfo

  constructor() {
    super();
    Room.CamStudy = this;

    Room.addEventListeners(this._CoreEvents, this);
    Room.ready(async e => {
      const {room, roomInfo} = Room.getRoomData();

      if(!Room.isCamStudy()){
        return;
      }

      const {setting} = roomInfo;
      [
        'useWaitingMode', 'useDocShare', 'useMediaShare',
        'useScreenShare', 'useExam', 'useCbt',
        'useSticker', 'useQnA', 'useMeetingNote',
        'useShareNote', 'useMirroring', 'useAIChatBot',
        'useRecord', 'useFileShare',

        'defaultRoleMic', 'useRoomGroup'
      ].forEach(name => {
        setting[name] = false;
      })

      this._eventListen(this.#Events);
      const camStudy = (await this.getCamStudyRoomInfo(room.roomId))?.camStudy;
      const userList = await this.getCamStudyUserList(room.roomId)
      const userBanList = await this.getCamStudyUserBanList()
      const hashTagList = (await this.getCamStudyRoomHashTagList())?.data
      const studyDataList = userList.filter(u=> !!u.camStudyUserData).map(u => Object.assign(u.camStudyUserData, {userId:u.userId}))
      const stopwatchList = userList.filter(u => !!u.stopwatch).map(u => Object.assign(u.stopwatch, {userId:u.userId}))
      // const personalSetting = await this.getPersonalSetting();
      const roomImagePath = (await this.getCamStudyRoomImage())?.data?.filePath
      let dDay = (await this.getUserDdayWidget()).data?.contents
      if(dDay) {
        try {
          dDay = JSON.parse(dDay)
        }catch (e) {
          console.error('pasing', e)
        }
      }
      Room.addRoomData({roomCamStudy: {camStudy, userList, userBanList, studyDataList, stopwatchList, hashTagList, roomImagePath, dDay}});

    }, {order: 100});
  }

  async getCamStudyUserProfile(data) {
    return (await camStudyService.getCamStudyUserProfile(data)).data
  }

  async getCamStudyRoomInfo(roomId) {
    if(!this.#camStudyRoomInfo) {
      this.#camStudyRoomInfo = (await camStudyService.getCamStudyRoomInfo(roomId)).data
    }
    return this.#camStudyRoomInfo;
  }

  async getCamStudyUserList(roomId) {
    return (await camStudyService.camStudyUserList(roomId)).data
  }

  async getCamStudyUserBanList() {
    return (await camStudyService.camStudyUserBanList()).data
  }

  async changeStopwatchState(state) {
    return await camStudyService.changeStopwatchState(state)
  }

  async resetStopwatch(resetData = false) {
    return await camStudyService.resetStopwatch(resetData)
  }

  async getTodayCamStudyData() {
    return (await camStudyService.getTodayCamStudyData()).data
  }

  async createTodayCamStudyUserData() {
    return await camStudyService.createTodayCamStudyUserData()
  }
  async modifyCamStudyInfo(data) {
    return await camStudyService.modifyCamStudy(data)
  }

  async addBanUser(data) {
    return await camStudyService.addBanUser(data)
  }

  async removeBanUser(data) {
    return await camStudyService.removeBanUser(data)
  }

  async changeStudyStatus(userId, data) {
    return await camStudyService.changeStudyStatus(userId, data)
  }

  async addUserPoint(data) {
    return await camStudyService.addUserPoint(data)
  }

  async getWhiteNoisePlayList() {
    return await camStudyService.getWhiteNoisePlayList()
  }

  async changeWhiteNoiseStatus(data) {
    return await camStudyService.changeWhiteNoiseStatus(data)
  }

  // async getPersonalSetting() {
  //   let personalSetting = Room.getRoomData().roomCamStudy?.personalSetting;
  //   if(personalSetting) {
  //     return Room.getRoomData().roomCamStudy.personalSetting;
  //   }
  //
  //   return (await camStudyService.getPersonalSetting()).data;
  // }

  // async modifyPersonalSetting(data) {
  //   const personalSetting = (await camStudyService.modifyPersonalSetting(data)).data;
  //   Room.getRoomData().roomCamStudy.personalSetting = personalSetting;
  //   Room.trigger('room_changePersonalSetting', personalSetting)
  //   return personalSetting
  // }

  async modifyRoomImageUrl(data) {
    return await camStudyService.modifyRoomImageUrl(data);
  }

  async getCamStudyRoomHashTagList() {
    return await camStudyService.getCamStudyRoomHashTagList();
  }

  async getCamStudyRoomImage() {
    return await camStudyService.getCamStudyRoomImage();
  }

  async getUserDdayWidget() {
    return await camStudyService.getUserDdayWidget();
  }

  async getUploadImageSasUrl(data) {
    return await camStudyService.getUploadImageSasUrl(data);
  }

  isStopwatchStartState(userId) {
    return this.getStopwatch(userId)?.state !== 'pause'
  }
  getStopwatch(userId) {
    return this.getCamstudyUser(userId).stopwatch
  }
  setCamstudyUserData(user) {
    const userList = Room.getRoomData().roomCamStudy?.userList
    if(!userList) return
    const u = userList?.find(u => u.userId === user.userId)
    if(u) {
      Object.assign(u, user)
    } else {
      userList.push(user)
    }
  }

  setCamStudyUserBanList(userBan) {
    const userBanList = Room.getRoomData().roomCamStudy?.userBanList
    const u = userBanList?.find(u => u.email === userBan.email)
    if(u) {
      Object.assign(u, userBan)
    } else {
      userBanList.push(userBan)
    }
  }
  removeCamStudyUserBanList(userBan) {
    const userBanList = Room.getRoomData().roomCamStudy?.userBanList
    const idx = userBanList?.findIndex(ub => ub.email === userBan.email)
    if (idx >= 0) {
      userBanList.splice(idx, 1)
    }
  }

  getCamstudyUser(userId) {
    const userList = Room.getRoomData().roomCamStudy?.userList || []
    return userList?.find(u => u.userId === userId)
  }

  changeWhiteNoisePlayList(data) {
      Room.trigger('room_changeWhiteNoise', data);
  }

  async inviteUser(data) {
    return await camStudyService.inviteUser(data)
  }

  async isJoinedEmail(email) {
    return await camStudyService.isJoinedEmail(email)
  }

  async convertToJpeg(file) {
    const bitmap = await createImageBitmap(file);
    const canvas = document.createElement('canvas');
    const size = Math.min(bitmap.width, bitmap.height);
    let ratio = 1; // 배율
    if(size < 360){
      ratio = 360 / size;
    }
    canvas.width = size * ratio;
    canvas.height = size * ratio;

    const ctx = canvas.getContext('2d');
    ctx.filter = 'blur(6px)';
    ctx.drawImage(
        bitmap, (bitmap.width - size) / 2, (bitmap.height - size) / 2, size, size,
        0, 0, canvas.width, canvas.height
    );
    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(new File([blob], 'tempFileName.jpg', { type: 'image/jpeg' }));
      }, 'image/jpeg');
    });
  }

  async getCamStudyUserStopWatchSetting(roomId, userId) {
    return (await camStudyService.getCamStudyUserStopWatchSetting(roomId, userId)).data
  }

  async saveUserStopWatchSetting(roomId, sendEvent, data) {
    return await camStudyService.saveUserStopWatchSetting(roomId, sendEvent, data);
  }

  async modifyCamStudyMyMsg(roomId, userId, myMsg) {
    return await camStudyService.modifyCamStudyMyMsg(roomId, userId, myMsg);
  }

  async getCamStudyUserInfo(roomId, userId) {
    return (await camStudyService.getCamStudyUserInfo(roomId, userId)).data
  }

  async checkUserPremium() {
    return (await camStudyService.checkUserPremium()).data;
  }

  async getCamStudyMyMsg(roomId, userId) {
    return (await camStudyService.getCamStudyMyMsg(roomId, userId)).data
  }

  async changeCamStudyType(data) {
    return await camStudyService.changeCamStudyType(data)
  }

  async changeCamStudyUserNickname(data) {
    return await camStudyService.changeCamStudyUserNickname(data);
  }

  async getCamStudyTrialInfo() {
    return await camStudyService.getCamStudyTrialInfo();
  }

  #Events = {
    room_cstudy_addUser(e) {
      this.setCamstudyUserData(e.data.camStudyUser)
      Room.emit(e)
    },
    room_cstudy_updateCamsutdyUser(e) {
      this.setCamstudyUserData(e.data.camStudyUser)
      Room.emit({
        type: 'room_cstudy_addUser',
        data: e.data
      })
    },
    room_cstudy_changeStopwatchState(e) {
      const user = e.data.camStudyUser
      user.stopwatch = e.data.stopwatch
      this.setCamstudyUserData(user)

      Room.emit(e)
    },
    room_cstudy_resetStopwatch(e) {
      const user = this.getCamstudyUser(e.data.userId)
      if(user) {
        user.stopwatch = e.data.stopwatch
      }
      Room.emit(e)
    },
    room_cstudy_banUser(e) {
      Room.emit({ type: 'room_cstudy_addBanUser', data: e.data})
      this.setCamStudyUserBanList(e.data.camStudyUserBan)
    },
    room_cstudy_removeBanUser(e) {
      Room.emit({ type: 'room_cstudy_removeBanUser', data: e.data})
      this.removeCamStudyUserBanList(e.data.camStudyUserBan)
    },
    room_cstudy_addUserPoint(e) {
      const user = this.getCamstudyUser(e.data.userId)
      if(user) {
        e.data.penalty ? (user.pPoint = e.data.pPoint) : (user.point = e.data.point)
      }
      Room.emit(e)
    },
    room_cstudy_changeWhiteNoiseStatus(e) {
      Room.emit(e);
    },
    room_cstudy_modifyCamStudy(e) {
      Room.changeRoomData({
        defaultCameraStatus: e.data.defaultCameraStatus,
        defaultMicStatus: e.data.defaultMicStatus,
        endResvDate: e.data.endResvDate,
        useVacancyDetection: e.data.useVacancyDetection,
        vacancyDetectMinutes: e.data.vacancyDetectMinutes,
        useDefinePasswd: e.data.useDefinePasswd,
        passwd: e.data.passwd,
      })

      Room.emit(e)
      if(e.data.useVacancyDetection !== undefined) {
        Room.trigger('room_cstudy_changeUseVacancy', e.data)
      }

      if(e.data.vacancyDetectMinutes !== undefined) {
        Room.trigger('room_cstudy_changeVacancyDetectMinutes', e.data)
      }
    },
    room_modifyRoomImageUrl(e) {
      Room.emit(e)
    },
    room_cstudy_modifyUserMyMsg(e) {
      const userId = e.data.userId
      const myMsg = e.data.myMsg
      const user = this.getCamstudyUser(userId)
      if(user) {
        user.myMsg = myMsg
      }
      Room.emit(e)
    },
    room_cstudy_changeUserItemSetting(e) {
      Room.emit(e)
    },
    room_cstudy_userVacancy(e) {
      Room.emit(e)
    },
    room_cstudy_changeUsername(e) {
      const camStudyUser = this.getCamstudyUser(e?.data?.userId)
      if(camStudyUser) {
        camStudyUser.username = e?.data?.username
      }
      Room.emit(e)
    },
    room_cstudy_changeUserProfileImage(e) {
      Room.emit(e)
    },
    room_cstudy_changeRoomType(e) {
      Room.emit(e);
    },
  }

  _CoreEvents = {
    room_vacancyDetectImageUpload: async function(e) {
      const file = await this.convertToJpeg(e.data.file);
      const type = e.data.type;
      const res = await this.getUploadImageSasUrl({ type: type } )
      const { roomImageUploadPath, presignedUrl } = res.data;

      if ( !presignedUrl ) {
        throw new Error('Could not get sas URL');
      }

      const cancel = new AbortController();
      let removed = false;
      try {
        await RoomFile.uploadToSasUrl({
          url: presignedUrl, file,
          onUploadProgress: e => {
            if (removed) {
              return;
            }
          },
          signal: cancel.signal
        })
      } catch (error) {
        cancel.abort();
        throw error;
      }
    },
  }
}

export const RoomCamStudy = new RoomCamStudyApi();